import React from "react";
import AppModalShell, { AppModalButton, AppModalContentItem } from "../common/AppModalShell";

const CLOSE_LABELS = {
  en: "Close invitation",
  sk: "Zavrieť pozvánku",
  ru: "Закрыть приглашение",
  cs: "Zavřít pozvánku",
};

export default function ModalCampaignModal({ campaign, open, onClose, onAction, language = "en" }) {
  if (!campaign) return null;
  const locale = String(language || "en").toLowerCase().split("-")[0];
  const copy = campaign.translations?.[locale] || campaign.translations?.en;
  if (!copy) return null;

  const panelStyle = {
    aspectRatio: "1054 / 1492",
    backgroundColor: "#071321",
    backgroundImage: `linear-gradient(180deg, rgba(3, 9, 20, .2) 0%, transparent 32%, rgba(3, 9, 20, .18) 47%, rgba(3, 9, 20, .92) 78%, #030914 100%), url(${JSON.stringify(campaign.background_url)})`,
    backgroundPosition: "center, center",
    backgroundRepeat: "no-repeat, no-repeat",
    backgroundSize: "100% 100%, contain",
  };

  return (
    <AppModalShell
      open={open}
      title={copy.title}
      titleClassName="!sr-only"
      maxWidthClassName="max-w-[460px]"
      closeAriaLabel={CLOSE_LABELS[locale] || CLOSE_LABELS.en}
      onClose={onClose}
      panelStyle={panelStyle}
      headerClassName="!pb-0"
      bodyClassName="flex flex-col justify-end !pb-3 !pt-0"
      footer={(
        <AppModalButton onClick={onAction} className="!bg-[#1772ff] !text-white">
          {copy.cta}
        </AppModalButton>
      )}
    >
      <AppModalContentItem className="mt-auto text-left">
        {copy.eyebrow ? (
          <p className="mb-2 text-[11px] font-bold uppercase tracking-[0.16em] text-[#c0d6ff]">
            {copy.eyebrow}
          </p>
        ) : null}
        <h2 className="text-[25px] font-bold leading-[1.08] tracking-tight text-white sm:text-[30px]">
          {copy.title}
        </h2>
        <p className="mt-2.5 text-[13px] font-medium leading-[1.45] text-white/90 sm:text-[14px]">
          {copy.body}
        </p>
      </AppModalContentItem>
    </AppModalShell>
  );
}
